export var EIconType;
(function (EIconType) {
    EIconType["Disabled"] = "disabled";
    EIconType["IsLoading"] = "isLoading";
    EIconType["InfoTooltip"] = "infoTooltip";
})(EIconType || (EIconType = {}));
